import { createRoute } from "@tanstack/react-router";
import { z } from "zod";

import { ResultsView } from "./components/ResultsView";

import { rootRoute } from "../root/route";

export const resultsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/sup-results",
  validateSearch(search: Record<string, unknown>) {
    return z
      .object({
        sessionId: z.string().optional(),
      })
      .parse(search);
  },
  component: ResultsView,
});
